import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Bell, History, Settings } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/Tabs';
import { ActiveAlerts } from '@/components/alerts/ActiveAlerts';
import { AlertHistory } from '@/components/alerts/AlertHistory';
import { ThresholdConfig } from '@/components/alerts/ThresholdConfig';
import { useCurrentFarm } from '@/hooks/useCurrentFarm';
import { RoleGuard } from '@/components/layout/RoleGuard';

export const Route = createFileRoute('/_app/alerts')({
  component: () => (
    <RoleGuard allowedRoles={['supervisor', 'owner', 'operator']}>
      <AlertsPage />
    </RoleGuard>
  ),
});

function AlertsPage() {
  const { farmId, isLoading: farmLoading } = useCurrentFarm();
  const [activeTab, setActiveTab] = useState('active');

  if (!farmId) {
    return farmLoading ? <div className="flex justify-center py-12">Loading...</div> : null;
  }

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Alerts</h1>
        <p className="text-gray-500">Monitor and manage farm alerts</p>
      </div>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-6">
          <TabsTrigger value="active">
            <span className="flex items-center gap-2">
              <Bell className="h-4 w-4" />
              Active Alerts
            </span>
          </TabsTrigger>
          <TabsTrigger value="history">
            <span className="flex items-center gap-2">
              <History className="h-4 w-4" />
              History
            </span>
          </TabsTrigger>
          <TabsTrigger value="thresholds">
            <span className="flex items-center gap-2">
              <Settings className="h-4 w-4" />
              Alert limits
            </span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="active">
          <ActiveAlerts farmId={farmId} />
        </TabsContent>

        <TabsContent value="history">
          <AlertHistory farmId={farmId} />
        </TabsContent>

        <TabsContent value="thresholds">
          <ThresholdConfig farmId={farmId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
